<template>
  <div :class="[{ error: error }, `form-field__${size}`]" class="form-field">
    <label :for="labelFor" class="form-field--label"
      >{{ label }}
      <InfoTooltip
        v-if="infoIcon"
        :text="infoText"
        :tooltipMinWidth="tooltipMinWidth"
        class="form-field--info-tooltip"
      />
    </label>

    <slot />

    <!-- FEEDBACK DE SUCESSO OU ERRO -->
    <transition name="fade">
      <p
        v-if="showFeedbackMessage && (error || success)"
        class="form-field--feedback"
      >
        {{ feedbackMessage }}
      </p>
    </transition>
  </div>
</template>

<script>
/**
 * * Componente que serve de base para os campos dos formulários
 */
import InfoTooltip from '../patterns/InfoTooltip'

export default {
  name: 'FormField',
  components: {
    InfoTooltip
  },
  props: {
    /** Label do campo */
    label: {
      type: String,
      default: 'Label do input'
    },
    /** Valor do atributo for */
    labelFor: {
      type: String,
      default: ''
    },
    /** Se o campo está com erro de validação */
    error: {
      type: Boolean,
      default: false
    },
    /** Se o campo passou na validação */
    success: {
      type: Boolean,
      default: false
    },
    /** Se deve mostrar uma mensagem de feedback caso ocorra erro */
    showErrorFeedbackMessage: {
      type: Boolean,
      default: false
    },
    /** Se deve mostrar uma mensagem de feedback caso ocorra sucesso */
    showSuccessFeedbackMessage: {
      type: Boolean,
      default: false
    },
    /** Texto da mensagem de feedback */
    feedbackMessage: {
      type: String,
      default: 'Campo obrigatório'
    },
    /** Se deve apresentar um ícone de informação sobre o campo */
    infoIcon: {
      type: Boolean,
      default: false
    },
    /** Texto de informação */
    infoText: {
      type: String,
      default: 'Informação sobre o campo'
    },
    /** largura mínima da tooltip */
    tooltipMinWidth: {
      type: [Number, String],
      default: 150
    },
    /**
     * Largura do campo
     * small, large, fluid
     */
    size: {
      type: String,
      default: 'fluid'
    }
  },
  computed: {
    showFeedbackMessage() {
      return this.showErrorFeedbackMessage || this.showSuccessFeedbackMessage
    }
  }
}
</script>

<style lang="scss" scoped>
.form-field {
  display: inline-block;
  position: relative;

  &--label {
    display: inline-flex;
    align-items: center;
    margin: 0;
    font-size: font-size('size-medium');
    font-weight: font-weight('weight-medium');
  }

  &--field {
    display: block;
    line-height: 2.8;
    width: 100%;
    border: none;
    border-bottom: 1px solid $gray-darkest;

    @include placeholder {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-normal');
      color: $gray-mid;
    }

    &:focus {
      border-color: $blue-2;
      border-bottom-width: 2px;
    }
  }

  &--feedback {
    position: absolute;
    left: 0;
    top: calc(100% + 3px);
    font-size: font-size('size-small');
    font-weight: font-weight('weight-medium');
  }

  &--info-tooltip {
    margin-left: 7px;
  }

  &.error {
    .form-field--field {
      border-color: $error;
      border-bottom-width: 2px;
    }

    .form-field--feedback {
      color: $error;
    }
  }

  &__fluid {
    width: 100%;
  }
  &__large {
    width: 230px;
  }
  &__small {
    width: 165px;
  }
}
</style>
